import { RefObject, useState } from 'react';

import { useResizeObserver } from 'hooks/ui/useResizeObserver';

const useMeasureHeaderHeight = (headerRef: RefObject<HTMLDivElement>) => {
  const [headerHeight, setHeaderHeight] = useState<number>();

  useResizeObserver(headerRef, () => {
    setHeaderHeight(headerRef.current?.clientHeight);
  });

  return {
    height: headerHeight,
    measurementReady: headerHeight !== undefined,
  };
};

export default useMeasureHeaderHeight;
